(() => {
  const selector = '[data-tui-cart-savings]';
  const messages = new Map();
  const observed = new WeakSet();
  let updating = false;
  const roots = () => Array.from(document.querySelectorAll(selector));
  const readCodes = root => {
    try { return JSON.parse(root.dataset.codes).filter(Boolean); } catch { return []; }
  };
  const normalized = code => code.trim().toUpperCase();
  const unique = codes => [...new Set(codes.map(normalized).filter(Boolean))];
  function money(amount, currency, wholeShillings = false) {
    const value = Number(amount) / 100;
    if (currency === 'KES') {
      const fractionDigits = wholeShillings || Number(amount) % 100 === 0 ? 0 : 2;
      return 'KSh ' + new Intl.NumberFormat('en-KE', {minimumFractionDigits:fractionDigits,maximumFractionDigits:fractionDigits}).format(value);
    }
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency}).format(value);
  }
  function paint(root) {
    const section = root.closest('[data-section-type]');
    section.querySelectorAll('[data-tui-money]').forEach(node => {
      const formatted = money(node.dataset.tuiMoney, root.dataset.currency, Boolean(node.closest('.tui-cart-savings__summary')));
      if (node.textContent !== formatted) node.textContent = formatted;
    });
    const subtotal = section.querySelector('.quick-cart__footer-subtotal span,.cart__footer-subtotal span');
    if (subtotal) subtotal.textContent = money(root.dataset.cartTotal, root.dataset.currency);
    root.querySelector('[data-tui-coupon-controls]').hidden = false;
    const state = messages.get(root.dataset.placement);
    const output = root.querySelector('[data-tui-code-message]');
    if (state) {
      output.textContent = state.text;
      output.toggleAttribute('data-error', state.error);
      const input = root.querySelector('[data-tui-code-input]');
      if (state.error) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
    }
    root.querySelectorAll('button,input').forEach(node => { node.disabled = updating; });
  }
  function message(root, key, error = false, shared = false) {
    const targets = shared ? roots() : [root];
    targets.forEach(target => {
      messages.set(target.dataset.placement, {text:target.dataset[key],error});
      paint(target);
    });
  }
  function initialize() {
    roots().forEach(paint);
    document.querySelectorAll('[data-section-type="cart"],[data-section-type="quick-cart"]').forEach(section => {
      if (observed.has(section)) return;
      observed.add(section);
      new MutationObserver(records => {
        for (const record of records) {
          for (const node of record.addedNodes) {
            if (node.nodeType !== 1) continue;
            if (node.matches(selector)) paint(node);
            node.querySelectorAll(selector).forEach(paint);
          }
        }
      }).observe(section, {childList:true,subtree:true});
    });
  }
  function refresh(cart) {
    if (typeof window.emit === 'function') {
      window.emit('cart:updated', {cart});
      window.emit('quick-cart:updated');
    } else {
      window.location.reload();
    }
  }
  function acceptedCodes(cart) {
    const codes = (cart.discount_codes || []).filter(code => code.applicable).map(code => code.code);
    const allocations = (cart.items || []).flatMap(item => item.line_level_discount_allocations || []);
    for (const application of [...(cart.cart_level_discount_applications || []), ...allocations.map(a => a.discount_application)]) {
      if (application?.type === 'discount_code') codes.push(application.title);
    }
    return unique(codes);
  }
  async function update(root, removeCode) {
    if (updating) return;
    const input = root.querySelector('[data-tui-code-input]');
    const newCode = normalized(input.value);
    if (removeCode === undefined && !newCode) {
      message(root, 'messageEmpty', true);
      input.focus();
      return;
    }
    updating = true;
    roots().forEach(paint);
    try {
      const base = window.Shopify.routes.root;
      const beforeResponse = await fetch(base + 'cart.js', {credentials:'same-origin',cache:'no-store'});
      if (!beforeResponse.ok) throw new Error('Cart read failed');
      const before = await beforeResponse.json();
      const existing = unique([...readCodes(root), ...acceptedCodes(before)]);
      const codes = removeCode === undefined ? unique([...existing,newCode]) : existing.filter(code => code !== normalized(removeCode));
      const response = await fetch(base + 'cart/update.js', {
        method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({discount:codes.join(',')})
      });
      if (!response.ok) throw new Error('Coupon update failed');
      const cart = await response.json();
      const accepted = acceptedCodes(cart);
      const applied = removeCode !== undefined ? !accepted.includes(normalized(removeCode)) : accepted.includes(newCode);
      message(root, removeCode !== undefined ? 'messageRemoved' : applied ? 'messageApplied' : 'messageIneligible', !applied, true);
      if (applied) input.value = '';
      refresh(cart);
    } catch {
      message(root, 'messageError', true);
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart.js', {credentials:'same-origin',cache:'no-store'});
        if (response.ok) refresh(await response.json());
      } catch {}
    } finally {
      updating = false;
      roots().forEach(paint);
    }
  }
  document.addEventListener('click', event => {
    const control = event.target.closest('[data-tui-code-apply],[data-tui-code-remove]');
    if (!control) return;
    event.preventDefault();
    update(control.closest(selector), control.hasAttribute('data-tui-code-remove') ? control.dataset.tuiCodeRemove : undefined);
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.matches('[data-tui-code-input]')) {
      event.preventDefault();
      update(event.target.closest(selector));
    }
  });
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
})();
